import { type RouteComponentProps, Router, useLocation, useNavigate } from '@reach/router'
import React, { type FC, useEffect, useState } from 'react'
import { ContentContainer } from '@awell/ui-kit/components/ContentContainer'
import { Tab } from '@awell-health/design-system'
import { t } from 'i18next'
import { WebhooksCallList } from '../WebhookList/WebhooksCallList'
import { ApiCallList } from '../ApiCallList'
import { AuditLogs } from '../AuditLogs'

export const PathwayLogsRoute: FC<RouteComponentProps> = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  // Determine current tab based on pathname
  const getCurrentTab = (): string => {
    if (pathname.includes('webhooks')) return 'webhooks'
    if (pathname.includes('audit-logs')) return 'audit-logs'
    return 'api-calls' // default
  }

  const [selectedTab, setSelectedTab] = useState(getCurrentTab())

  // Update selected tab when pathname changes
  useEffect(() => {
    setSelectedTab(getCurrentTab())
  }, [pathname])

  const tabs = [
    {
      id: 'api-calls',
      label: t('api_call_other'),
      onClick: () => {
        setSelectedTab('api-calls')
        void navigate('api-calls')
      }
    },
    {
      id: 'webhooks',
      label: t('webhook_other'),
      onClick: () => {
        setSelectedTab('webhooks')
        void navigate('webhooks')
      }
    },
    {
      id: 'audit-logs',
      label: t('audit_log_other'),
      onClick: () => {
        setSelectedTab('audit-logs')
        void navigate('audit-logs')
      }
    }
  ]

  return (
    <section className="bg-white h-full">
      <ContentContainer>
        <>
          <div className="flex flex-col gap-2 mb-4">
            <div className="text-2xl font-medium">{t('logs')}</div>
            <div className="text-base text-gray-500">{t('logs_description')}</div>
          </div>

          <div className="my-6">
            <Tab items={tabs} selected={selectedTab} fullWidth={false} variant="bordered" size="md" />
          </div>

          <Router>
            <WebhooksCallList path="webhooks" />
            <ApiCallList path="api-calls" />
            <AuditLogs path="audit-logs" />
          </Router>
        </>
      </ContentContainer>
    </section>
  )
}

PathwayLogsRoute.displayName = 'PathwayLogsRoute'
